import { ROUTES } from '@router/constants.ts';

export const getSidebarKeys = () => {
    return {
        ASSESSMENT: ROUTES.SIDEBAR.ASSESSMENT,
        LEARNING: ROUTES.SIDEBAR.LEARNING,
        PROGRESS: ROUTES.SIDEBAR.PROGRESS,
        SURVEY: ROUTES.SIDEBAR.SURVEY,
        ELEMENTS: ROUTES.SIDEBAR.ELEMENTS,
        PATHWAYS: ROUTES.SIDEBAR.PATHWAYS,
        ADMIN: ROUTES.SIDEBAR.ADMIN.ROOT,
        SETTINGS: ROUTES.SIDEBAR.SETTINGS,
        HELP_CENTER: ROUTES.SIDEBAR.HELP_CENTER,
        ASK: ROUTES.SIDEBAR.ASK,
        PERFORM: ROUTES.SIDEBAR.PERFORM,
    };
};
